import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { OrnamentalDividerComponent } from '@web/shared/ui';

@Component({
  selector: 'app-section-title-with-ornament',
  imports: [OrnamentalDividerComponent],
  templateUrl: './section-title-with-ornament.component.html',
  styleUrl: './section-title-with-ornament.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionTitleWithOrnamentComponent {
  public readonly withTitle = input(true);
  public readonly withSubtitle = input(true);
}
